import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import { reducer as reduxAsyncConnect } from 'redux-connect'

import auth from './auth'
import createAppReducer from './app'
import api from './api'
import wizard from './wizard'
import images from './images'
import files from './files'
import { reducer as form } from 'redux-form'

export default (history, params) => combineReducers({
  reduxAsyncConnect,
  router: connectRouter(history),
  app: createAppReducer(params),
  auth,
  form,
  wizard,
  images,
  files,
  api
})
